:host {
  --font-family: 'Montserrat', sans-serif;
  --body-size: var(--body-size-medium);
  height: auto;
}

.subsection-title {
  height: 32px;
  margin-bottom: calc(var(--spacer) * 3);
}

#login-security-section {
  margin-bottom: calc(var(--spacer) * 4);

  #authentication-method {
    height: 32px;
  }

  #check-status-description {
    margin-top: var(--spacer);
    height: 72px;
  }

  #two-fa-info {
    margin-top: var(--spacer);
    height: 45px;
    width: 870px;
    box-sizing: border-box;
    line-height: 25px;
  }

  #two-fa-enable-steps gz-enumeration-icon {
    display: block;
    margin-top: var(--spacer);
  }

  #reset-2fa-description {
    margin-top: var(--spacer);
    height: 16px;
    width: 598px;
    box-sizing: border-box;
    line-height: normal;
  }

  #user-password {
    margin-top: calc(var(--spacer) * 4);
    height: 32px;
  }

  #revoke-reset-description {
    margin-top: calc(var(--spacer) * 3);
    height: 32px;
    line-height: 25px;
    box-sizing: border-box;
  }

  #revoke-button {
    margin-top: calc(var(--spacer) * 2);
    height: 24px;
    padding: 2px 2px 2px 2px;
    box-sizing: border-box;
  }

  #reset-button {
    margin-left: 3px;
    margin-top: calc(var(--spacer) * 2);
    height: 24px;
    padding: 2px 2px 2px 2px;
  }

  #after-reset-description {
    margin-top: calc(var(--spacer) * 2);
    height: 32px;
    width: 598px;
    line-height: normal;
    box-sizing: border-box;
  }

  #password-expiration {
    margin-top: calc(var(--spacer) * 3);

    #password-expiration-description {
      width: 844px;
      height: 32px;
      box-sizing: border-box;
      margin-top: var(--spacer);
      line-height: normal;
    }
  }

  #account-lockout {
    margin-top: calc(var(--spacer) * 2);
    padding-top: var(--spacer);

    #account-lockout-description {
      width: 844px;
      height: 32px;
      box-sizing: border-box;
      margin-top: var(--spacer);
      line-height: normal;
    }
  }

  #concurrent-sessions {
    margin-top: calc(var(--spacer) * 2);
    padding-top: var(--spacer);

    #concurrent-sessions-description {
      width: 844px;
      height: 32px;
      box-sizing: border-box;
      margin-top: var(--spacer);
      line-height: normal;
    }
  }

}
